module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tooltipVisible) ? _c('div', {
    ref: "mapTooltip",
    staticClass: "tooltip",
    style: (_vm.tooltipStyle),
    attrs: {
      "id": "tooltip"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.tooltipText)
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dbc6b62","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/callcenter/components/MapMarkerTooltip.vue
// module id = 1518
// module chunks = 17